import { Typography } from '../../../common';
import './miniCard.scss';

interface MiniCardProps {
  value: string;
  heading: string;
  iconClassName: string;
  containerBg?: string;
  imageContainerBg?: string;
}

const MiniCard = ({
  value,
  heading,
  iconClassName,
  containerBg = '',
  imageContainerBg = '',
}: MiniCardProps) => {
  return (
    <div
      className="miniCard-container"
      style={{ backgroundColor: containerBg || undefined }}
    >
      <div className="value">
        <Typography variant="h2">{value}</Typography>
      </div>
      <div className="heading">
        <Typography variant="h3">{heading}</Typography>
      </div>
      <div
        className="image-container"
        style={{ backgroundColor: imageContainerBg || undefined }}
      >
        <img src={iconClassName} alt="icon" />
      </div>
    </div>
  );
};

export default MiniCard;
